import { render, staticRenderFns } from "./MenuAuthApi.vue?vue&type=template&id=fd7995f2&scoped=true&"
import script from "./MenuAuthApi.vue?vue&type=script&lang=js&"
export * from "./MenuAuthApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7995f2",
  null
  
)

export default component.exports